<template>
  <div class="appContainer my-code">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('my-code-page.header', { split: '/' }) }}</h1>
    </div>

    <h4
      class="left-border"
      v-html="$t('my-code-page.description-title', { split: '<br>' })"
    ></h4>

    <div class="code-container">
      <div class="blank"></div>
      <div class="code">
        <h3 v-html="$t('my-code-page.qr-label', { split: '<br>' })"></h3>

        <div class="code-info">
          <p
            class="title"
            v-html="
              $t('my-code-page.number-register-label', {
                split: '<br>'
              })
            "
          ></p>
          <!-- #E8320D -->
          <v-btn
            large
            :style="
              getColorCodeFromJapaneseLevel(
                applicant_entry !== null && applicant_entry.jlpt_level
              )
            "
            class="orderCode"
            >{{ getApplicantEntry }}</v-btn
          >

          <p
            class="title"
            v-html="$t('my-code-page.qr-code', { split: '/' })"
          ></p>
          <div class="qr-box">
            <qrcode :value="valueQrCode" :options="{ width: 150 }"></qrcode>
          </div>
        </div>
      </div>
      <div class="blank"></div>
    </div>

    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  JAPANESE_COLOR_DEFAULT,
  JAPANESE_TEXT_COLOR_DEFAULT
} from '@/common/constants';
import ScrollTopBtn from '@/components/ScrollTopBtn';

export default {
  components: {
    ScrollTopBtn
  },
  computed: {
    ...mapGetters({
      c_japanese_level: 'getCJapaneseLevel',
      applicant: 'getBasicInfomation',
      applicant_entry: 'getEntryInfomation'
    }),

    valueQrCode: function () {
      let value = null;
      if (this.applicant !== null) {
        const entry_no = this.applicant.entry_no;
        value = {
          entry_no: entry_no,
          contract_id: this.checkEvent.contract_id,
          event_code: this.checkEvent.event_code
        };
      }

      return JSON.stringify(value);
    }
  },

  methods: {
    getColorCodeFromJapaneseLevel: function (jlpt_level) {
      const arr = this.c_japanese_level.filter((ele) => ele.id === jlpt_level);

      if (arr.length > 0) {
        return {
          backgroundColor: '#' + arr[0].color_code,
          borderColor: '#' + arr[0].color_code,
          color: '#' + arr[0].text_color_code
        };
      } else
        return {
          backgroundColor: JAPANESE_COLOR_DEFAULT,
          borderColor: JAPANESE_COLOR_DEFAULT,
          color: JAPANESE_TEXT_COLOR_DEFAULT
        };
    }
  }
};
</script>

<style lang="scss">
@import './qrCode.scss';
</style>
